const logoOverrides: Record<string, string> = {
  amz: '/home-portal/images/marketplaceLogos/amazon_us.png',
  a2z: '/home-portal/images/marketplaceLogos/amazon_eu.png',
}

export const getLogoOverride = (siteAbb: string): string | undefined => {
  const strippedAbb = siteAbb.replace(/-i$/, '')
  return logoOverrides[strippedAbb]
}
